/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
import { slug } from '../../common';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.facade_manager.toolbar`;

export default class BannerListToolbar extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		return (
			<div className="BannerListToolbar">
				<div className="BannerListToolbar-item">
					<label className="BannerListToolbar-label">{t(`${prfx}.sort_label`)}</label>
					<SelectDropdown buttonClassName="Button Button--secondary" caretIcon="far fa-chevron-down">
						{this.sortOptions.toArray()}
					</SelectDropdown>
				</div>
				<div className="BannerListToolbar-item">
					<label className="BannerListToolbar-label">{t(`${prfx}.active_filter_label`)}</label>
					<SelectDropdown buttonClassName="Button Button--secondary" caretIcon="far fa-chevron-down">
						{this.positionFilterOptions.toArray()}
					</SelectDropdown>
				</div>
				<div className="BannerListToolbar-item">
					<label className="BannerListToolbar-label">{t(`${prfx}.active_filter_label`)}</label>
					<SelectDropdown buttonClassName="Button Button--secondary" caretIcon="far fa-chevron-down">
						{this.activeFilterOptions.toArray()}
					</SelectDropdown>
				</div>
			</div>
		);
	}

	get sortOptions() {
		const { state } = this.attrs;

		const options = new ItemList();
		const sortMap = state.sortMap();

		const sortOptions = {};
		for (const key in sortMap) {
			sortOptions[key] = t(`${prfx}.sort.${key}`);
		}

		Object.keys(sortOptions).forEach((key) => {
			const label = sortOptions[key];
			const active = (state.getParams().sort || Object.keys(sortMap)[0]) === key;

			options.add(
				key,
				<Button active={active} icon={active ? 'fas fa-check' : true} onclick={state.changeSort.bind(state, key)}>
					{label}
				</Button>
			);
		});

		return options;
	}

	get activeFilterOptions() {
		const { state } = this.attrs;

		const options = new ItemList();
		const filterMap = state.activeFilterMap();

		const filterOptions = {};
		for (const key in filterMap) {
			filterOptions[key] = t(`${prfx}.active_filter.${key}`);
		}

		Object.keys(filterOptions).forEach((key) => {
			const label = filterOptions[key];

			let active = false;
			const currentFilter = state.getParams().filter ?? {};
			if (!currentFilter['active'] && !currentFilter['-active'] && Object.keys(filterMap)[0] === key) {
				active = true;
			} else if (currentFilter[filterMap[key]]) {
				active = true;
			}

			options.add(
				key,
				<Button active={active} icon={active ? 'fas fa-check' : true} onclick={state.changeFilter.bind(state, 'active', key)}>
					{label}
				</Button>
			);
		});

		return options;
	}

	get positionFilterOptions() {
		const { state } = this.attrs;

		const options = new ItemList();
		const filterMap = state.positionFilterMap();

		const filterOptions = {};
		for (const key in filterMap) {
			filterOptions[key] = t(`${prfx}.position_filter.${key}`);
		}

		Object.keys(filterOptions).forEach((key) => {
			const label = filterOptions[key];

			let active = false;
			const currentFilter = state.getParams().filter ?? {};
			if (!currentFilter['position'] && Object.keys(filterMap)[0] === key) {
				active = true;
			} else if (currentFilter['position'] === key) {
				active = true;
			}

			options.add(
				key,
				<Button active={active} icon={active ? 'fas fa-check' : true} onclick={state.changeFilter.bind(state, 'position', key)}>
					{label}
				</Button>
			);
		});

		return options;
	}
}
